import React, { useContext } from "react"
import { Controller } from "react-hook-form"
import CheckboxWithLabelForForm from "~/components/ui/CheckboxWithLabelForForm"
import { FormContext } from "~/contexts/FormContext"

interface Props {
  field: string
  label: string
}

const CheckboxInput: React.FC<Props> = ({ field, label }) => {
  const form = useContext(FormContext)
  if (!form) return null
  return (
    <Controller
      name={field}
      control={form.control}
      render={({ field: { onChange, value } }) => (
        <CheckboxWithLabelForForm label={label} name={field} value={value} setValue={onChange} />
      )}
    />
  )
}

export default CheckboxInput
